import {
  DELETE_INVESTMENT_HOLDING_DIVIDEND_INCOME,
  GET_INVESTMENT_HOLDING_DIVIDEND_INCOME,
  POST_INVESTMENT_HOLDING_DIVIDEND_INCOME,
  PUT_INVESTMENT_HOLDING_DIVIDEND_INCOME,
  COPY_INVESTMENT_HOLDING_DIVIDEND_INCOME_FROM_PREVIOUS_YEARS,
} from "../constants/actionTypes";

const defaultState = {}
let data=[]
export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_INVESTMENT_HOLDING_DIVIDEND_INCOME:
        return {...state,...action.payload};
      case POST_INVESTMENT_HOLDING_DIVIDEND_INCOME:
        return {...action.payload};
      case PUT_INVESTMENT_HOLDING_DIVIDEND_INCOME:
        return {...state,...action.payload};
      case DELETE_INVESTMENT_HOLDING_DIVIDEND_INCOME:
        data = [...state.dividendIncomeArr];
        const newData = data?.filter(
          (income) => income.id != action.payload,
        );
        return {...state, dividendIncomeArr: [...newData]};
      case COPY_INVESTMENT_HOLDING_DIVIDEND_INCOME_FROM_PREVIOUS_YEARS:
        return {
          ...state,
          dividendIncomeArr: Array.isArray(action.payload) 
            ? [...action.payload]
            : state.dividendIncomeArr,
        };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
